module.exports = __webpack_public_path__ + "static/media/lastSection.10f3100b.png";